import version from '../../version';

export const environment = {
  version,
  production: true,
  API_URL: 'https://api.skynet.mcanism.com',
  dsnSentry: 'https://9c87ffd94d654cb0af42ba49e0d7d80d@o4504282426114048.ingest.sentry.io/4505169090707456',
  environment: 'production',
  tracesSampleRate: 0.25,
  recaptchaSiteKey: '6LdB-8EqAAAAAGYnSIm4_jCxEgB1RZNwlGBrVmhC',
};
